import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { overview_fetchData, overviewdataSelector, overviewdata_setFrom, overviewdata_setTo, overviewdata_setType, overviewdata_setVendor } from "reducers/overview/overviewdata";
import { getUser } from "services/auth";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import enGB from "date-fns/locale/en-GB";

import { parseISO, format } from 'date-fns';
import { renderDropdown } from "components/MediaTel/DropdownAutoComplete";
import { appdataSelector } from "reducers/appdata/appdata";
registerLocale("de", enGB);

function OverviewHeader() {
    const dispatch = useDispatch();
    const overviewdata = useSelector(overviewdataSelector);
    const appdata = useSelector(appdataSelector);

    useEffect(() => {
        console.log("new overview",overviewdata.from)


        var a = new Date();
        let fuu = parseISO(JSON.parse(overviewdata.from));

        // fromdata is today, change it and fetchdata

        if (a.getDate() === fuu.getDate() && a.getFullYear() === fuu.getFullYear() && a.getMonth() === fuu.getMonth()) {
            console.log("overview fromdata is today", a.getDate(), fuu.getDate())
            let s = a.setMonth(a.getMonth() - 2);
            a = new Date(s);

            dispatch(overviewdata_setFrom(JSON.stringify(new Date(a))));
            dispatch(overviewdata_setType(0));

        }



    }, [])

    useEffect(() => {

        if (overviewdata.to && overviewdata.from && overviewdata.type > -1) {
            console.log("overview, dispatch");
            dispatch(overview_fetchData())
        }

    }, [overviewdata.to, overviewdata.from, overviewdata.type, overviewdata.vendor])

    const handleChangeType = (event) => {
        console.log("change type to", event.target.value);
        dispatch(overviewdata_setType(event.target.value))
    }

    const handleChangeDate = (date, type) => {
        console.log("change date", date, type);

        if (type == "from") {
            dispatch(overviewdata_setFrom(JSON.stringify(new Date(date))))
        }
        else {
            dispatch(overviewdata_setTo(JSON.stringify(new Date(date))))
        }

    }

    const handleVendorChange = (value, type = null) => {
        console.log("handle vendor change", value);
        dispatch(overviewdata_setVendor(value));
    }

    let vendorSelected = "";
    if (
        appdata.listvalues.vendorsForSearch
    ) {
        appdata.listvalues.vendorsForSearch.map((item, key) => {
            if (item["LIFNR"] === overviewdata.vendor)
                vendorSelected = item;
        });
    }

    let from = parseISO(JSON.parse(overviewdata.from));
    let to = parseISO(JSON.parse(overviewdata.to));

    console.log("frommie", from, to);

    return <div className="headerdiv ">

        <span>
            Type:&nbsp;
            <select
                key="plantselect"
                id="plantselect"
                name="plantselect"
                onChange={handleChangeType}
                value={overviewdata.type ? overviewdata.type : ""}
                className="d-print-none"
            >
                <option key="type0" value="0">
                    requires my action
                </option>
                <option key="type1" value="1">
                    created by me
                </option>
                <option key="type2" value="2">
                    all mine approved
                </option>
                <option key="type3" value="3">
                    all mine rejected
                </option>
                {getUser()["isAdmin"] && (
                    <React.Fragment>
                        <option key="type4" value="4">
                            all
                        </option>
                        <option key="type5" value="5">
                            all open
                        </option>
                        <option key="type6" value="6">
                            all final approved
                        </option>
                        <option key="type7" value="7">
                            all rejected
                        </option>
                    </React.Fragment>
                )}
            </select>
        </span>
        <span className="overviewHeaderSpan">
            From:&nbsp;
            <DatePicker
                selected={from ? from : ""}
                onChange={date => handleChangeDate(date, "from")}
                name="startDate"
                dateFormat="dd.MM.yyyy"
                id="startDate"
                locale="de"
                allowSameDay={false}
                maxDate={new Date().setDate(new Date().getDate() - 1)}
            />
        </span>

        <span className="overviewHeaderSpan">
            Until:&nbsp;
            <DatePicker
                selected={to ? to : ""}
                onChange={date => handleChangeDate(date, "to")}
                name="endDate"
                dateFormat="dd.MM.yyyy"
                id="endDate"
                locale="de"
            />
        </span>
        <span style={{ bottom: 0, right: 0, position: "absolute" }}>
            {renderDropdown(
                "Vendor",
                appdata.listvalues["vendorsForSearch"],
                vendorSelected,
                "LIFNR",
                "LIFNR",
                ["LIFNR", "COMP_NAME"],
                handleVendorChange
            )}
        </span>
    </div>
}

export default OverviewHeader